<span class="api-title">
    <span class="api-title-chip" [class]="getColor(apiMethod)">{{apiMethod}}</span>
    <span class="api-title-url">{{url}}</span>
</span>